var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w-40" },
    [
      _c("dropdown-component", {
        attrs: { value: _vm.recruiterId, values: _vm.dropdownOptions },
        on: { input: _vm.handleApplicantRecruiterChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }